import React from 'react';
import { DashboardLayout } from '../../components/DashboardLayout';
import { Card, CardContent } from '../../components/ui/card';
import { Ticket } from 'lucide-react';

export const LottoEmployee = () => {
  return (
    <DashboardLayout>
      <div className="space-y-6">
        {/* Header */}
        <div>
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 dark:text-gray-100">Lotto</h1>
          <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">Lotto-Verkäufe und Informationen</p>
        </div>

        {/* Placeholder Content */}
        <Card>
          <CardContent className="flex flex-col items-center justify-center py-16">
            <div className="p-4 bg-green-100 rounded-full mb-4">
              <Ticket className="h-12 w-12 text-green-600" />
            </div>
            <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">Lotto-Modul in Vorbereitung</h2>
            <p className="text-gray-600 dark:text-gray-400 text-center max-w-md">
              Hier können Sie bald Lotto-Verkäufe verwalten und Informationen einsehen.
            </p>
          </CardContent>
        </Card>
      </div>
    </DashboardLayout>
  );
};
